module.exports = __webpack_public_path__ + "static/ishan-f931e0e5e8242e06c64a57572c58fc1b.png";